"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubtractiveGenerator = void 0;
class SubtractiveGenerator {
    constructor(seed) {
        this.MAX = 1000000000;
        this.state = new Array(55).fill(0);
        const temp = new Array(55).fill(0);
        temp[0] = this.mod(seed);
        temp[1] = 1;
        for (let i = 2; i < 55; ++i) {
            temp[i] = this.mod(temp[i - 2] - temp[i - 1]);
        }
        for (let i = 0; i < 55; ++i) {
            this.state[i] = temp[(34 * (i + 1)) % 55];
        }
        this.pos = 54;
        for (let i = 55; i < 220; ++i) {
            this.next();
        }
    }
    next() {
        const temp = this.mod(this.state[(this.pos + 1) % 55] - this.state[(this.pos + 32) % 55]);
        this.pos = (this.pos + 1) % 55;
        this.state[this.pos] = temp;
        return temp;
    }
    nextFloat() {
        return this.next() / this.MAX; // Normalize to [0, 1]
    }
    mod(n) {
        return ((n % this.MAX) + this.MAX) % this.MAX;
    }
}
exports.SubtractiveGenerator = SubtractiveGenerator;
